import {observable} from "@nx-js/observer-util";
import {Services} from "../../Services";
import {ICommunityArticleModel} from "../../../models/community/article/ICommunityArticleModel";
import {
    ICommunityArticleRatingTermModel
} from "../../../models/community/article/rating/term/ICommunityArticleRatingTermModel";
import {AccountService} from "../../account/AccountService";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {Network} from "../../../network/Network";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {ProductType} from "../../../models/product/ProductType";
import {ICommunityModel} from "../../../models/community/ICommunityModel";
import {ICommunityArticleUpdateModel} from "../../../models/community/article/ICommunityArticleUpdateModel";
import {ErrorCode} from "../../../network/status/error/ErrorCode";
import {Resources} from "../../../resources/Resources";
import {WebSocketCommunityEventName} from "../../../network/socket/names/WebSocketCommunityEventName";
import {WebSocketEventName} from "../../../network/socket/names/WebSocketEventName";
import {NetworkSocket} from "../../../network/socket/NetworkSocket";
import {
    ICommunityArticleGenerateOutgoing
} from "../../../models/community/article/ai/generate/ICommunityArticleGenerateOutgoing";
import {
    ICommunityArticleSectionsOutgoing
} from "../../../models/community/article/ai/sections/ICommunityArticleSectionsOutgoing";
import {
    ICommunityArticleSectionsAskOutgoing
} from "../../../models/community/article/ai/sections/ICommunityArticleSectionsAskOutgoing";
import {
    ICommunityArticleProposalIncomingModel
} from "../../../models/community/article/ai/proposals/ICommunityArticleProposalIncomingModel";
import {
    ICommunityArticleSectionIncomingModel
} from "../../../models/community/article/ai/sections/ICommunityArticleSectionIncomingModel";
import {
    ICommunityArticleSectionsUpdate
} from "../../../models/community/article/ai/sections/ICommunityArticleSectionsUpdate";
import {CommunityFilesService} from "../files/CommunityFilesService";
import {arrayRemove} from "../../../sedestral/framework/utilities/ArrayRemove";
import {
    ICommunityArticleLinkEnrichIncoming
} from "../../../models/community/article/link/ICommunityArticleLinkEnrichIncoming";
import {
    ICollaborationEditorCommunitySavingArticleMetadataOutgoingModel
} from "../../../models/collaboration/editor/saving/community/outgoing/ICollaborationEditorCommunitySavingArticleMetadataOutgoingModel";
import {
    ICommunityArticleStepKeywordOutgoing
} from "../../../models/community/article/ai/keyword/ICommunityArticleStepKeywordOutgoing";
import {
    ICommunityArticleStepRulesOutgoing
} from "../../../models/community/article/ai/rules/ICommunityArticleStepRulesOutgoing";
import {
    ICommunityArticleStepSourcesOutgoing
} from "../../../models/community/article/ai/sources/ICommunityArticleStepSourcesOutgoing";
import {
    ICommunityArticlesLastUserContextsModel
} from "../../../models/community/article/ICommunityArticlesLastUserContextsModel";
import {CommunityArticleAIState} from "../../../models/community/article/ai/CommunityArticleAIState";
import {ICommunityArticleRatingModel} from "../../../models/community/article/rating/ICommunityArticleRatingModel";
import {
    ICommunityArticleWaitingAdminModel
} from "../../../models/community/articles/ICommunityArticleWaitingAdminModel";
import {
    ICommunityArticleRatingTermsOverview
} from "../../../models/community/article/rating/term/ICommunityArticleRatingTermsOverview";
import {
    ICommunityArticleStepSelectTermsOutgoing
} from "../../../models/community/article/rating/term/ICommunityArticleStepSelectTermsOutgoing";
import {ICommunityArticleLinksIncoming} from "../../../models/community/article/link/ICommunityArticleLinksIncoming";
import {
    ICommunityArticleContentVersioningModel
} from "../../../models/community/article/ICommunityArticleContentVersioningModel";
import {ICommunityArticleImportModel} from "../../../models/community/article/ICommunityArticleImportModel";
import {ICommunityArticlesOverviews} from "../../../models/community/article/ICommunityArticlesOverviews";
import {
    ICommunityArticleStepOptimizationOutgoing
} from "../../../models/community/article/ai/optimization/ICommunityArticleStepOptimizationOutgoing";
import {filterXSS, filterXSSRichHtml} from "../../../sedestral/framework/utilities/FilterXSS";
import {CommunityArticleFormat} from "../../../models/community/article/CommunityArticleFormat";
import {ICommunityArticleOverview} from "../../../models/community/article/ICommunityArticleOverview";
import {
    ICommunityArticleContentsOverviewOutgoing
} from "../../../models/community/article/ICommunityArticleContentsOverviewOutgoing";
import {
    ICommunityKeywordExampleModel
} from "../../../models/community/article/keyword/ICommunityKeywordExampleModel";
import {
    ICommunityArticleKeywordEvaluationIncoming
} from "../../../models/community/article/keyword/ICommunityArticleKeywordEvaluationIncoming";
import {
    ICommunityArticleKeywordEvaluationOutgoing
} from "../../../models/community/article/keyword/ICommunityArticleKeywordEvaluationOutgoing";
import {
    ICommunityArticleKeywordSuggestionsOutgoing
} from "../../../models/community/article/keyword/ICommunityArticleKeywordSuggestionsOutgoing";
import {ICommunityArticleKeywordCoverageOutgoing} from "../../../models/community/article/keyword/ICommunityArticleKeywordCoverageOutgoing";
import {ICommunityArticleKeywordCoverageIncoming} from "../../../models/community/article/keyword/ICommunityArticleKeywordCoverageIncoming";
import {
    ICommunityArticleKeywordSuggestionsIncoming
} from "../../../models/community/article/keyword/ICommunityArticleKeywordSuggestionsIncoming";
import {ICommunityGEOSerpModel} from "../../../models/community/article/geo/ICommunityGEOSerpModel";
import {
    ICommunityArticleAiChatOutgoing
} from "../../../models/community/article/ai/chat/ICommunityArticleAiChatOutgoing";
import {
    ICommunityArticleAiChatAppliedReportOutgoing
} from "../../../models/community/article/ai/chat/ICommunityArticleAiChatAppliedReportOutgoing";
import {
    ICommunityArticleAiChatMessageModel
} from "../../../models/community/article/ai/chat/ICommunityArticleAiChatMessageModel";
import {
    ICommunityArticleAiChatActionResultModel
} from "../../../models/community/article/ai/chat/ICommunityArticleAiChatActionResultModel";
import {
    ICommunityArticleAiChatEditsModel
} from "../../../models/community/article/ai/chat/ICommunityArticleAiChatEditsModel";
import {
    ICommunityArticleAiChatEditModel
} from "../../../models/community/article/ai/chat/ICommunityArticleAiChatEditModel";
import {
    ICommunityArticleAiChatStepModel
} from "../../../models/community/article/ai/chat/ICommunityArticleAiChatStepModel";

interface IAiChatListeners {
    ackEvents: (() => void)[];
    stepEvents: ((step: ICommunityArticleAiChatStepModel) => void)[];
    editsEvents: ((edits: ICommunityArticleAiChatEditsModel) => void)[];
    endEvents: (() => void)[];
    errorEvents: ((error: any) => void)[];
}

export class CommunityArticleService {

    public static NB_MAX_SECTIONS_BY_ITEM: number = 7;

    public static articles: ICommunityArticleModel[] = observable([]);
    public static createEvents: ((article: ICommunityArticleModel) => void)[] = [];
    public static deleteEvents: ((article: ICommunityArticleModel) => void)[] = [];
    public static updateEvents: ((article: ICommunityArticleModel) => void)[] = [];

    public static proposalEvents: ((proposal: ICommunityArticleProposalIncomingModel) => void)[] = [];
    public static sectionEvents: ((section: ICommunityArticleSectionIncomingModel) => void)[] = [];
    public static ratingUpdateEvents: ((rating: ICommunityArticleRatingModel) => void)[] = [];
    public static transferErrorEvents: (() => void)[] = [];

    public static joinedArticleId: string;

    private static aiChatListenersByAskId: Map<string, IAiChatListeners> = new Map();

    public static dispose(): void {
        this.createEvents = [];
        this.deleteEvents = [];
        this.updateEvents = [];
        this.proposalEvents = [];
        this.sectionEvents = [];
        this.ratingUpdateEvents = [];
        this.transferErrorEvents = [];
        this.aiChatListenersByAskId.clear();
    }

    public static init(): void {
        window["CommunityArticleService"] = this;

        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_ARTICLE_CREATE,
            (data) => {
                let article = this.store(data);
                this.createEvents.forEach(value => value(article));
            });

        Network.on(ProductType.COMMUNITY, WebSocketEventName.ALERT,
            (alertCode) => {
                if (alertCode == NetworkSocket.TRANSFER_ERROR_ALERT) {
                    this.transferErrorEvents.forEach(value => value());
                }
            });

        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_ARTICLE_UPDATE,
            (data) => {
                let article = this.store(data);
                this.updateEvents.forEach(value => value(article));
            });

        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_ARTICLE_DELETE,
            (data) => {
                let article = this.store(data);
                this.deleteEvents.forEach(value => value(article));
            });

        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_ARTICLE_PROPOSAL_CREATE,
            (proposal: ICommunityArticleProposalIncomingModel) => {
                this.storeProposal(proposal);
                this.proposalEvents.forEach(value => value(proposal));
            });

        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_ARTICLE_SECTION_CREATE,
            (section: ICommunityArticleSectionIncomingModel) => {
                this.storeSection(section);
                this.sectionEvents.forEach(value => value(section));
            });

        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_ARTICLE_RATING_UPDATE,
            (data: ICommunityArticleRatingModel) => {
                this.ratingUpdateEvents.forEach(value => value(data));
            });

        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_ARTICLE_AI_CHAT_ACK,
            (event: { askId: string }) => {
                const listeners = this.aiChatListenersByAskId.get(event.askId);
                if (listeners) {
                    listeners.ackEvents.forEach(callback => callback());
                }
            });

        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_ARTICLE_AI_CHAT_STEP,
            (event: { askId: string, step: ICommunityArticleAiChatStepModel }) => {
                const listeners = this.aiChatListenersByAskId.get(event.askId);
                if (listeners) {
                    listeners.stepEvents.forEach(callback => callback(event.step));
                }
            });

        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_ARTICLE_AI_CHAT_EDITS,
            (event: ICommunityArticleAiChatEditsModel) => {
                const listeners = this.aiChatListenersByAskId.get(event.askId);
                if (listeners) {
                    listeners.editsEvents.forEach(callback => callback(event));
                }
            });

        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_ARTICLE_AI_CHAT_END,
            (event: { askId: string }) => {
                const listeners = this.aiChatListenersByAskId.get(event.askId);
                if (listeners) {
                    listeners.endEvents.forEach(callback => callback());
                    this.aiChatListenersByAskId.delete(event.askId);
                }
            });

        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_ARTICLE_AI_CHAT_ERROR,
            (event: { askId: string, error: string }) => {
                const listeners = this.aiChatListenersByAskId.get(event.askId);
                if (listeners) {
                    listeners.errorEvents.forEach(callback => callback(event.error));
                    this.aiChatListenersByAskId.delete(event.askId);
                }
            });
    }

    /**
     * websocket
     */

    static onCreateEvent(component: INetworkComponent, func: (article: ICommunityArticleModel) => void) {
        this.createEvents.push(func);
        component.onRemove(() => arrayRemove(this.createEvents, func));
    }

    static onDeleteEvent(component: INetworkComponent, func: (article: ICommunityArticleModel) => void) {
        this.deleteEvents.push(func);
        component.onRemove(() => arrayRemove(this.deleteEvents, func));
    }

    static onUpdateEvent(component: INetworkComponent, func: (article: ICommunityArticleModel) => void) {
        this.updateEvents.push(func);
        component.onRemove(() => arrayRemove(this.updateEvents, func));
    }

    static onTransferErrorEvent(component: INetworkComponent, func: () => void) {
        this.transferErrorEvents.push(func);
        component.onRemove(() => arrayRemove(this.transferErrorEvents, func));
    }

    static onProposalEvent(component: INetworkComponent, func: (proposal: ICommunityArticleProposalIncomingModel) => void) {
        this.proposalEvents.push(func);
        component.onRemove(() => arrayRemove(this.proposalEvents, func));
    }

    static onSectionEvent(component: INetworkComponent, func: (section: ICommunityArticleSectionIncomingModel) => void) {
        this.sectionEvents.push(func);
        component.onRemove(() => arrayRemove(this.sectionEvents, func));
    }

    static onRatingUpdateEvent(component: INetworkComponent, func: (generate: ICommunityArticleRatingModel) => void) {
        this.ratingUpdateEvents.push(func);
        component.onRemove(() => arrayRemove(this.ratingUpdateEvents, func));
    }

    /**
     * http
     */
    public static async createByPageTracking(pageTrackingId: string, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        Services.handleErrors(component, [
            {
                status: HttpStatus.NOT_FOUND,
                message: Resources.t("words.importContentError")
            }
        ]);

        let request = await Network.post(ProductType.COMMUNITY, "/community/article/createByPageTracking", {
            pageTrackingId: pageTrackingId
        }, component);

        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async onboarding(communityId: string, component?: INetworkComponent): Promise<string[]> {
        Services.handleErrors(component, [
            {
                status: HttpStatus.UNAUTHORIZED,
                message: "none"
            },
        ]);

        let request = await Network.post(ProductType.COMMUNITY, `/community/article/onboarding/${communityId}`, {}, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return [];
    }

    public static async keywordExamples(communityId: string, component?: INetworkComponent): Promise<ICommunityKeywordExampleModel[]> {
        Services.handleErrors(component, [
            {
                status: HttpStatus.UNAUTHORIZED,
                message: "none"
            },
        ]);

        let request = await Network.post(ProductType.COMMUNITY, `/community/article/keyword-examples/${communityId}`, {}, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return [];
    }

    public static async stepOptimization(communityArticleStepOptimization: ICommunityArticleStepOptimizationOutgoing, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        let request = await Network.postJson(ProductType.COMMUNITY, "/community/article/step/optimization", communityArticleStepOptimization, component);
        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }
        return undefined;
    }

    public static async stepKeyword(keyword: ICommunityArticleStepKeywordOutgoing, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        Services.handleErrors(component, [
            {errorCode: ErrorCode.SIZE_MAX, message: Resources.t("words.maxProposalsPerItem")}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, "/community/article/step/keyword", keyword, component);

        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }
        return undefined;
    }

    public static async evaluateKeyword(data: ICommunityArticleKeywordEvaluationOutgoing, component?: INetworkComponent): Promise<ICommunityArticleKeywordEvaluationIncoming> {
        Services.handleErrors(component, [
            {status: HttpStatus.NOT_FOUND, message: "none"},
            {status: HttpStatus.TOO_MANY_REQUESTS, message: "none"},
            {status: HttpStatus.INTERNAL_SERVER_ERROR, message: "none"},
            {status: HttpStatus.SERVICE_UNAVAILABLE, message: "none"},
            {status: HttpStatus.BAD_GATEWAY, message: "none"},
            {defaultError: true, message: "none"}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, "/community/article/keyword/evaluate", data, component);

        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async getKeywordCoverage(data: ICommunityArticleKeywordCoverageOutgoing, component?: INetworkComponent): Promise<ICommunityArticleKeywordCoverageIncoming> {
        Services.handleErrors(component, [
            {status: HttpStatus.NOT_FOUND, message: "none"},
            {status: HttpStatus.INTERNAL_SERVER_ERROR, message: "none"},
            {status: HttpStatus.SERVICE_UNAVAILABLE, message: "none"},
            {defaultError: true, message: "none"}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, "/community/article/keyword/coverage", data, component);

        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async getKeywordSuggestions(data: ICommunityArticleKeywordSuggestionsOutgoing, component?: INetworkComponent): Promise<ICommunityArticleKeywordSuggestionsIncoming> {
        Services.handleErrors(component, [
            {status: HttpStatus.NOT_FOUND, message: "none"},
            {status: HttpStatus.INTERNAL_SERVER_ERROR, message: "none"},
            {status: HttpStatus.SERVICE_UNAVAILABLE, message: "none"},
            {defaultError: true, message: "none"}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, "/community/article/keyword/suggestions", data, component);

        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async stepSelectTerms(terms: ICommunityArticleStepSelectTermsOutgoing, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        let request = await Network.postJson(ProductType.COMMUNITY, "/community/article/step/manual/selectTerms", terms, component);
        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }
        return undefined;
    }

    public static async addCustomTerm(articleId: string, keyword: string, component?: INetworkComponent): Promise<ICommunityArticleRatingTermModel> {
        let request = await Network.postJson(ProductType.COMMUNITY, "/community/article/term/custom", {
            articleId: articleId,
            keyword: keyword
        }, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async getLinks(articleId: string, proposalItemIndex: number, component?: INetworkComponent): Promise<ICommunityArticleLinksIncoming> {
        let request = await Network.post(ProductType.COMMUNITY, "/community/article/links", {
            articleId: articleId,
            proposalItemIndex: proposalItemIndex
        }, component);

        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async getInternalLinks(communityId: string, component?: INetworkComponent): Promise<ICommunityArticleLinksIncoming> {
        let request = await Network.post(ProductType.COMMUNITY, "/community/article/links/internal", {
            communityId: communityId
        }, component);

        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async aiStepSourcesValidate(sources: ICommunityArticleStepSourcesOutgoing, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        let request = await Network.postJson(ProductType.COMMUNITY, "/community/article/step/ai/sources", sources, component);
        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }
        return undefined;
    }

    public static async aiStepSourcesUpdate(sources: ICommunityArticleStepSourcesOutgoing, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        Services.handleErrors(component, [
            {status: HttpStatus.NOT_FOUND, message: "none"},
            {status: HttpStatus.UNAUTHORIZED, message: "none"}
        ]);

        let request = await Network.putJson(ProductType.COMMUNITY, "/community/article/step/ai/sources", sources, component);
        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }
        return undefined;
    }

    public static async enrichLink(communityId: string, url: string, component?: INetworkComponent): Promise<ICommunityArticleLinkEnrichIncoming> {
        Services.handleErrors(component, [
            {status: HttpStatus.NOT_FOUND, message: "none"},
            {status: HttpStatus.UNAUTHORIZED, message: "none"}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, "/community/article/link/enrich", {
            communityId: communityId,
            url: url
        }, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async aiStepRulesValidate(rules: ICommunityArticleStepRulesOutgoing, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        Services.handleErrors(component, [
            {errorCode: ErrorCode.GPT_RETRY_LIMIT, message: Resources.t("words.maxRetryLimit")},
            {errorCode: ErrorCode.SIZE_MAX, message: Resources.t("words.maxRetryLimit")}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, "/community/article/step/ai/rules", rules, component);
        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }
        return undefined;
    }

    public static async aiStepRulesUpdate(rules: ICommunityArticleStepRulesOutgoing, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        Services.handleErrors(component, [
            {status: HttpStatus.NOT_FOUND, message: "none"},
            {status: HttpStatus.UNAUTHORIZED, message: "none"},
            {errorCode: ErrorCode.GPT_RETRY_LIMIT, message: "none"},
            {errorCode: ErrorCode.SIZE_MAX, message: "none"}
        ]);

        let request = await Network.putJson(ProductType.COMMUNITY, "/community/article/step/ai/rules", rules, component);
        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }
        return undefined;
    }

    public static async aiProposalsRetry(p: {
        articleId: string,
        index: number
    }, component?: INetworkComponent): Promise<ICommunityArticleModel> {

        Services.handleErrors(component, [
            {errorCode: ErrorCode.GPT_RETRY_LIMIT, message: Resources.t("words.maxRetryLimit")}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, `/community/article/ai/proposals/retry`, p, component);

        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }

        return undefined;
    }

    public static async aiProposalsCustom(p: {
        articleId: string,
        index: number,
        title: string,
        description: string
    }, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/article/ai/proposals/custom`, p, component);

        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }

        return undefined;
    }

    public static async aiSections(p: ICommunityArticleSectionsOutgoing, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        Services.handleErrors(component, [
            {errorCode: ErrorCode.GPT_RETRY_LIMIT, message: Resources.t("words.maxRetryLimit")},
            {errorCode: ErrorCode.SIZE_MAX, message: Resources.t("words.maxRetryLimit")}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, `/community/article/ai/sections`, p, component);

        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }

        return undefined;
    }

    public static async aiSectionsRetry(p: {
        articleId: string,
        index: number
    }, component?: INetworkComponent): Promise<ICommunityArticleModel> {

        Services.handleErrors(component, [
            {errorCode: ErrorCode.GPT_RETRY_LIMIT, message: Resources.t("words.maxRetryLimit")}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, `/community/article/ai/sections/retry`, p, component);

        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }

        return undefined;
    }

    public static async aiSectionsUpdate(p: ICommunityArticleSectionsUpdate, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/article/ai/sections/update`, p, component);

        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }

        return undefined;
    }

    public static async aiSectionsAsk(p: ICommunityArticleSectionsAskOutgoing, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        Services.handleErrors(component, [
            {errorCode: ErrorCode.GPT_RETRY_LIMIT, message: Resources.t("words.maxRetryLimit")},
            {errorCode: ErrorCode.SIZE_MAX, message: Resources.t("words.maxRetryLimit")}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, `/community/article/ai/sections/ask`, p, component);

        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }

        return undefined;
    }

    public static async aiGenerate(p: ICommunityArticleGenerateOutgoing, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        Services.handleErrors(component, [
            {errorCode: ErrorCode.GPT_RETRY_LIMIT, message: Resources.t("words.maxRetryLimit")}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, `/community/article/ai/generate`, p, component);

        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }

        return undefined;
    }

    public static async reloadGeoCoverage(articleId: string, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        let request = await Network.post(ProductType.COMMUNITY, `/community/article/geo/reload`, {articleId}, component);

        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }

        return undefined;
    }

    public static async getGeoSerp(geoSerpId: string, component?: INetworkComponent): Promise<ICommunityGEOSerpModel> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/geo-serp/${geoSerpId}`, component);

        if (request.status == HttpStatus.OK) {
            return request.data;
        }

        return undefined;
    }

    public static async lastUserContexts(communityId: string, component?: INetworkComponent): Promise<ICommunityArticlesLastUserContextsModel[]> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/article/last-user-contexts/${communityId}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async findById(id: string, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/article/${id}`, component);
        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }

        return undefined;
    }

    public static async apiExport(id: string, component?: INetworkComponent): Promise<any> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/article/${id}/export`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }

        return undefined;
    }

    public static async update(update: ICommunityArticleUpdateModel, component?: INetworkComponent): Promise<boolean> {
        Services.handleErrors(component, [
            {errorCode: ErrorCode.ROUTE_EXIST, message: Resources.t("words.routeExist")}
        ]);

        let request = await Network.putJson(ProductType.COMMUNITY, `/community/article`, update, component);
        if (request.status == HttpStatus.OK) {
            this.store(request.data);
            return true;
        }

        return false;
    }

    public static async publishPage(articleId: string, url: string, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        let request = await Network.post(ProductType.COMMUNITY, `/community/article/page/publish`, {
            articleId: articleId,
            url: url
        }, component);

        if (request.status == HttpStatus.OK) {
            const article = this.store(request.data);
            this.updateEvents.forEach(value => value(article));
            return article;
        }
        return undefined;
    }


    public static async schedule(articleId: string, scheduledPublishTime: number, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        Services.handleErrors(component, [
            {errorCode: ErrorCode.SCHEDULED_TIME_IN_PAST, message: Resources.t("words.scheduledTimeInPast")},
            {errorCode: ErrorCode.SCHEDULED_TIME_TOO_FAR, message: Resources.t("words.scheduledTimeTooFar")}
        ]);

        let request = await Network.postJson(ProductType.COMMUNITY, `/community/article/schedule`, {
            articleId: articleId,
            scheduledPublishTime: scheduledPublishTime
        }, component);

        if (request.status == HttpStatus.OK) {
            const article = this.store(request.data);
            this.updateEvents.forEach(value => value(article));
            return article;
        }
        return undefined;
    }

    public static async unschedule(articleId: string, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        let request = await Network.post(ProductType.COMMUNITY, `/community/article/unschedule`, {
            articleId: articleId
        }, component);

        if (request.status == HttpStatus.OK) {
            const article = this.store(request.data);
            this.updateEvents.forEach(value => value(article));
            return article;
        }
        return undefined;
    }

    public static async delete(articleId: string, component?: INetworkComponent): Promise<ICommunityModel> {
        let request = await Network.delete(ProductType.COMMUNITY, `/community/article/${articleId}`, component);
        if (request.status == HttpStatus.OK) {
            this.unStore(request.data);
        }

        return undefined;
    }

    public static async getRatingTermOverview(objectId: string, ratingId: string, term: string, component?: INetworkComponent): Promise<ICommunityArticleRatingTermsOverview> {
        let request = await Network.post(ProductType.COMMUNITY, "/community/article/rating/term/overview",
            {
                objectId: objectId,
                ratingId: ratingId,
                term: term
            }, component);

        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async switchContentVersioning(articleId: string, contentVersioningId: string, component?: INetworkComponent): Promise<ICommunityArticleContentVersioningModel> {
        let request = await Network.post(ProductType.COMMUNITY, "/community/article/switchContentVersioning",
            {articleId: articleId, contentVersioningId: contentVersioningId},
            component);

        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async getContentsVersioning(articleId: string, component?: INetworkComponent): Promise<ICommunityArticleContentVersioningModel[]> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/article/contentsVersioning/${articleId}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async importContent(communityId: string, format: CommunityArticleFormat, mainKeyword?: string, url?: string, remoteId?: string, localId?: string, component?: INetworkComponent): Promise<ICommunityArticleImportModel> {
        Services.handleErrors(component, [
            {
                status: HttpStatus.NOT_FOUND,
                message: Resources.t("words.importFailedContentTooSmall")
            },
            {
                status: HttpStatus.UNAUTHORIZED,
                message: Resources.t("words.importFailedContentTooSmall")
            },
        ]);

        let request = await Network.post(ProductType.COMMUNITY, "/community/article/import", {
            communityId: communityId,
            format: format,
            mainKeyword: mainKeyword,
            url: url,
            remoteId: remoteId,
            localId: localId
        }, component);

        if (request.status == HttpStatus.OK) {
            let imported: ICommunityArticleImportModel = request.data;
            if (imported.title)
                imported.title = filterXSS(imported.title);
            if (imported.html)
                imported.html = filterXSSRichHtml(imported.html);
            if (imported.snippet)
                imported.snippet = filterXSS(imported.snippet);

            return imported;
        }
    }

    public static async importOverview(communityId: string, format: CommunityArticleFormat, url?: string, remoteId?: string, localId?: string, component?: INetworkComponent): Promise<ICommunityArticleOverview> {
        Services.handleErrors(component, [
            {
                status: HttpStatus.NOT_FOUND,
                message: Resources.t("words.importFailedContentTooSmall")
            },
        ]);

        let request = await Network.post(ProductType.COMMUNITY, "/community/article/overview/import", {
            communityId: communityId,
            format: format,
            url: url,
            remoteId: remoteId,
            localId: localId
        }, component);

        if (request.status === HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async getLastContentsOverview(incoming: ICommunityArticleContentsOverviewOutgoing, component?: INetworkComponent): Promise<ICommunityArticlesOverviews> {
        let request = await Network.postJson(ProductType.COMMUNITY, "/community/article/contents/overview", incoming, component);

        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async refreshSerp(articleId: string, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        let request = await Network.post(ProductType.COMMUNITY, "/community/article/refreshSerp", {
            articleId: articleId
        }, component);

        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }
        return undefined;
    }

    public static async retrySerpError(articleId: string, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        let request = await Network.post(ProductType.COMMUNITY, "/community/article/retrySerpError", {
            articleId: articleId
        }, component);

        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }
        return undefined;
    }

    public static async retryKnowledgeError(articleId: string, component?: INetworkComponent): Promise<ICommunityArticleModel> {
        let request = await Network.post(ProductType.COMMUNITY, "/community/article/retryKnowledgeError", {
            articleId: articleId
        }, component);

        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }
        return undefined;
    }

    public static async getWaitingArticlesAdmin(component?: INetworkComponent): Promise<ICommunityArticleWaitingAdminModel[]> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/admin/article/waiting`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    /**
     * websocket
     */

    public static async join(id: string) {
        if (id != null) {
            await Network.join(ProductType.COMMUNITY, id, WebSocketCommunityEventName.COMMUNITY_ARTICLE_JOIN);
            this.joinedArticleId = id;
        }
    }


    public static leave(id: string) {
        Network.emit(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_ARTICLE_LEAVE, id);
        this.joinedArticleId = undefined;
    }

    /**
     * store
     */
    public static storeAll(articles: ICommunityArticleModel[]): ICommunityArticleModel[] {
        for (let key in articles) {
            articles[key] = this.store(articles[key]);
        }
        return Services.storeAll(articles);
    }

    public static storeProposal(proposal: ICommunityArticleProposalIncomingModel) {
        let article = this.articles.find(value => value.id == proposal.articleId);
        if (article && article.proposals) {
            article.proposals.items[proposal.index].proposals.push(proposal.proposal);
        }
    }

    public static storeSection(section: ICommunityArticleSectionIncomingModel) {
        let article = this.articles.find(value => value.id == section.articleId);
        if (article && article.sections) {
            article.sections.items[section.indexSection].sections.push(section.section);
        }
    }

    public static store(article: ICommunityArticleModel): ICommunityArticleModel {
        let storedArticle = Services.get("id", this.articles, article.id);
        if (storedArticle != undefined) {

            if (article.writersAccounts.length == 0 && storedArticle.writersAccounts.length !== 0) {
                article.writersAccounts = storedArticle.writersAccounts;
            }

            if (article.writersRedactors.length == 0 && storedArticle.writersRedactors.length !== 0) {
                article.writersRedactors = storedArticle.writersRedactors;
            }
        }

        if (article.imageFile) {
            article.imageFile = CommunityFilesService.store(article.imageFile);
        }

        AccountService.storeAll(article.writersAccounts);
        return Services.store("id", this.articles, article);
    }

    public static unStore(article: ICommunityArticleModel): void {
        Services.unStore("id", this.articles, article);
    }

    public static storeMetadata(metadata: ICollaborationEditorCommunitySavingArticleMetadataOutgoingModel) {
        if (metadata.imageFile) {
            metadata.imageFile = CommunityFilesService.store(metadata.imageFile);
        }

        AccountService.storeAll(metadata.writersAccounts);
    }

    public static getMainKeyword(article: ICommunityArticleModel): string {
        const doneSection = article?.sections?.items.find(
            section => section.state === CommunityArticleAIState.DONE);

        return doneSection
            ? article?.proposals?.items[doneSection.index]?.keywords?.[0] ?? ""
            : "";
    }

    public static async aiChat(outgoing: ICommunityArticleAiChatOutgoing, component?: INetworkComponent): Promise<string | undefined> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/article/ai/agent`, outgoing, component);
        if (request?.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    /**
     * Exécute une action que l'agent a proposée sans la faire lui-même (publier, changer la
     * couverture…) : c'est le clic de l'utilisateur qui la confirme. Le compte rendu revient en texte.
     */
    public static async aiChatAction(articleId: string, askId: string, actionId: string,
                                     component?: INetworkComponent): Promise<ICommunityArticleAiChatActionResultModel | undefined> {
        let request = await Network.post(ProductType.COMMUNITY, `/community/article/ai/agent/action`, {
            articleId: articleId,
            askId: askId,
            actionId: actionId
        }, component);
        if (request?.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async aiChatHistory(articleId: string, component?: INetworkComponent): Promise<ICommunityArticleAiChatMessageModel[]> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/article/${articleId}/ai/chat`, component);
        if (request?.status == HttpStatus.OK) {
            return request.data;
        }
        return [];
    }

    /**
     * Accuse l'application des modifications d'un échange : le serveur peut alors libérer la charge
     * utile qu'il gardait pour un éventuel rejeu. Idempotent, donc appelable sans état.
     */
    public static async aiChatApplied(articleId: string, askId: string, component?: INetworkComponent,
                                      report?: ICommunityArticleAiChatAppliedReportOutgoing): Promise<boolean> {
        let request = await Network.post(ProductType.COMMUNITY, `/community/article/ai/chat/applied`, {
            articleId: articleId,
            askId: askId,
            ...(report ?? {})
        }, component);
        return request?.status == HttpStatus.OK;
    }

    /**
     * Le détail d'un échange : le bloc tel qu'il était et tel qu'il est devenu, pour chaque
     * modification. Conservé hors du fil, il n'est chargé que lorsqu'on ouvre une carte.
     */
    public static async aiChatEdits(articleId: string,
                                    askId: string,
                                    component?: INetworkComponent): Promise<ICommunityArticleAiChatEditModel[]> {
        let request = await Network.get(ProductType.COMMUNITY,
            `/community/article/${articleId}/ai/chat/${askId}/edits`, component);
        if (request?.status == HttpStatus.OK) {
            return request.data;
        }
        return [];
    }

    /**
     * Trace l'annulation d'un lot : sans elle, la relecture montrerait des modifications que
     * l'article ne porte plus. Idempotent.
     */
    public static async aiChatReverted(articleId: string, askId: string, component?: INetworkComponent): Promise<boolean> {
        let request = await Network.post(ProductType.COMMUNITY, `/community/article/ai/chat/reverted`, {
            articleId: articleId,
            askId: askId
        }, component);
        return request?.status == HttpStatus.OK;
    }

    /**
     * L'utilisateur a annulé une seule modification du lot : la trace vit sur l'édit du détail,
     * le message entier ne bascule en annulé que quand plus rien d'appliqué ne subsiste. Idempotent.
     */
    public static async aiChatRevertedEdit(articleId: string, askId: string, editIndex: number,
                                           component?: INetworkComponent): Promise<boolean> {
        let request = await Network.post(ProductType.COMMUNITY, `/community/article/ai/chat/reverted-edit`, {
            articleId: articleId,
            askId: askId,
            editIndex: editIndex
        }, component);
        return request?.status == HttpStatus.OK;
    }

    public static listenAiChat(askId: string,
                               component: INetworkComponent,
                               onEdits: (edits: ICommunityArticleAiChatEditsModel) => void,
                               onEnd: () => void,
                               onError: (error: any) => void,
                               onAck: () => void,
                               onStep: (step: ICommunityArticleAiChatStepModel) => void): () => void {

        let listeners = this.aiChatListenersByAskId.get(askId);
        if (!listeners) {
            listeners = {
                ackEvents: [],
                stepEvents: [],
                editsEvents: [],
                endEvents: [],
                errorEvents: []
            };
            this.aiChatListenersByAskId.set(askId, listeners);
        }

        listeners.editsEvents.push(onEdits);
        listeners.endEvents.push(onEnd);
        listeners.errorEvents.push(onError);
        listeners.ackEvents.push(onAck);
        listeners.stepEvents.push(onStep);

        const dispose = () => {
            const currentListeners = this.aiChatListenersByAskId.get(askId);
            if (currentListeners) {
                arrayRemove(currentListeners.editsEvents, onEdits);
                arrayRemove(currentListeners.endEvents, onEnd);
                arrayRemove(currentListeners.errorEvents, onError);
                arrayRemove(currentListeners.ackEvents, onAck);
                arrayRemove(currentListeners.stepEvents, onStep);

                if (currentListeners.ackEvents.length === 0 &&
                    currentListeners.stepEvents.length === 0 &&
                    currentListeners.editsEvents.length === 0 &&
                    currentListeners.endEvents.length === 0 &&
                    currentListeners.errorEvents.length === 0) {
                    this.aiChatListenersByAskId.delete(askId);
                }
            }
        };

        component.onRemove(dispose);
        return dispose;
    }
}
